import validatejs from 'validate.js';
import moment from 'moment';
import Payment from 'payment';
import * as Yup from "yup";

validatejs.validators.noands = function (value, options, key, attributes) {
  // if full word of and (/b modifier locks to a full word) or & used, return message
  // return null / undefined is same as a valid validation.
  if (/\b(and)\b/gi.test(value) || /&/g.test(value)) {
    return options.message ? options.message : "Please donate as an individual";
  }
};

validatejs.validators.isVisaOrMastercard = function (value) {
  return ["visa", "mastercard"].includes(Payment.fns.cardType(value)) ? undefined : "Please enter a valid VISA or Mastercard number";
};

const recursiveReset = (obj) => {
  Object.keys(obj).map((key) => {
    // Test if it's an Object
    if (obj[key] === Object(obj[key])) {
      recursiveReset(obj[key]);
      return;
    }
    if (obj[key] instanceof Array) obj[key] = [];
    else obj[key] = null;
  });
};

function Validate(values, formValidationRules, options) {
  const validationStatus = validatejs(values, formValidationRules, options);

  // Before using datetime, we must add the parse and format functions
  validatejs.extend(validatejs.validators.datetime, {
    // The value is guaranteed not to be null or undefined but otherwise it could be anything.
    parse(value, options) {
      return +moment.utc(value);
    },
    // Input is a unix timestamp
    format(value, options) {
      const format = options.dateOnly ? "YYYY-MM-DD" : "YYYY-MM-DD hh:mm:ss";
      return moment.utc(value).format(format);
    },
  });

  const reset = JSON.parse(JSON.stringify({ ...values }));
  recursiveReset({ reset });
  const Final = { ...reset, ...validationStatus };
  return Final;
}

export const validatePassword = Yup.string()
  .required("Please enter a password")
  .test({
    test: (value, { createError }) => {
      if (!value) return true;
      const errorsArray = [];
      if (value.length < 8) errorsArray.push("at least 8 characters");
      if (!/\d/.test(value)) errorsArray.push("at least 1 number");
      if (!/[a-z]/.test(value)) errorsArray.push("at least 1 lowercase letter");
      if (!/[A-Z]/.test(value)) errorsArray.push("at least 1 uppercase letter");
      if (!/[^a-zA-Z0-9]/.test(value)) errorsArray.push("at least 1 special character");
      if (errorsArray.length === 0) return true;
      let errorString = errorsArray.join(", ");
      errorString = errorString.replace(/, ([^,]*)$/, " and $1");
      return createError({ message: `Please enter a password of  ${errorString}` });
    },
  });

export default Validate;
